import request from '@/utils/request'

export function loginGsm(data) {
  return request({
    url: '/api-auth/oauth/user/token',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "client_id": "sangfor",
      "client_secret": "webApp",
    }
  })
}

export function loginPp(data) {
  return request({
    url: '/api-auth/oauth/user/pptoken',
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

export function outPp(data) {
  return request({
    url: '/api-auth/oauth/remove/pptoken',
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

export function outGsm(data) {
  return request({
    url: '/api-auth/oauth/remove/token',
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

export function getPpuserInfo() {
  return request({
    url: '/api-user/sys/ppuser/info',
    method: 'get',
  })
}
export function getGsmInfo() {
  return request({
    url: '/api-user/sys/user/info',
    method: 'get',
  })
}
// 渠道idt 根据 code 获取 idt token
export function getTokenByPartnerIDT(data) {
  return request({
    url: `/api-auth/kbOauth/getTokenByPartnerIDT`,
    method: "post",
    data,
  });
}

// 内部idt根据code获取idt token
export function getUserAndTokenByCode(data){
  return request({
    url: `/api-auth/kbOauth/getUserAndTokenByCode`,
    method: "post",
    data,
  });
}
//内部idt 登出
export function removeIdtToken(params) {
  return request({
    url: `/api-auth/kbOauth/remove/token`,
    method: "get",
    params
  });
}
// 渠道idt 登出
export function removeTokenByPIDT(data) {
  return request({
    url: "/api-auth/kbOauth/removeTokenByPIDT",
    method: "post",
    data: data,
  });
}

export function sendEmail(data) {
  return request({
    url: '/sf-partnerportal/pp/user/ppLoginMail',
    method: 'post',
    data: data
  })
}
export function menuTreeList(id) {
  return request({
    url: '/api-kb/article/front/menuTreeList',
    method: 'post',
    data: id
  })
}

export function checkLoginApi() {
  return request({
    url: `/api-kb/system/gpt/isGsmUser`,
    method: "post",
  });
}
